import { FunctionComponent } from "react";
import "../assets/styles/Landing/Landing.css";
import Navbar from "../components/Navbar/Navbar";
import MainSection from "../components/MainSection/MainSection";
import MyTimeline from "../components/Timeline/Timeline";
import PrivateVisits from "../components/PrivateVisits/PrivateVisits";
import NFZ from "../components/NFZ/NFZ";
import Hospitals from "../components/Hospitals/Hospitals";
import Footer from "../components/Footer/Footer";
import NavbarMobile from "../components/Navbar/NavbarMobile";

interface LandingProps {}

const Landing: FunctionComponent<LandingProps> = () => {
  return (
    <div className="landing">
      <Navbar />
      <NavbarMobile />
      <MainSection />
      <MyTimeline />
      <NFZ />
      <Hospitals />
      <PrivateVisits />
      <Footer />
    </div>
  );
};

export default Landing;
